import React, { useEffect, useRef, useState } from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import ButtonTag from "../../../reusebale/button";
import LabelTag from "../../../reusebale/label";
import { Plus, Trash } from "lucide-react";
import db from "../../../../db/index.json";
import IconCards from "../../../reusebale/iconCards";
import * as LeaseAction from "../../../../store/actions/lease/LeaseAction";
import { useDispatch, useSelector } from "react-redux";
import { ShowError } from "../../../../utils/ToasFunction";
const RentCharges = ({
  formData,
  isChargeLate,
  onLatePercentageChange,
  onLateGraceDays,
  onLateFixedAmountChange,
  onLateInterestRateChange,
  onAdditionalCharges,
  onItemDeleteChanges,
}) => {

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectOpt, setSelectOpt] = useState("Select Charges");
  const dropdownRef = useRef(null);
  const [selectedCharges, setSelectedCharges] = useState([]);
  const chargeList = [
    {
      heading: "Operating Expenses (OpEx)",
      list: [
        {
          id: "1",
          title: "Property Taxes",
        },
        {
          id: "2",
          title: "Insurance (Property + Liability)",
        },
        {
          id: "3",
          title: "Property Management Fees",
        },
        {
          id: "4",
          title: "Maintenance & Repairs",
        },
        {
          id: "5",
          title: "Landscaping & Grounds",
        },
        {
          id: "6",
          title: "Trash & Recycling",
        },
        {
          id: "7",
          title: "Pest Control",
        },
        {
          id: "8",
          title: "Security / Lighting",
        },
        {
          id: "9",
          title: "Utilities (Common Area)",
        },
        {
          id: "10",
          title: "Accounting / Legal",
        },
        {
          id: "11",
          title: "Septic Maint",
        },
        {
          id: "12",
          title: "Contract Services",
        },
      ],
    },
    {
      heading: "Capital Expenditures (CapEx)",
      list: [
        {
          id: "14",
          title: "Roof Replacement",
        },
        {
          id: "15",
          title: "HVAC Replacement",
        },
        {
          id: "16",
          title: "Exterior Painting",
        },
        {
          id: "17",
          title: "Roll-Up Door Repairs/Replace",
        },
        {
          id: "18",
          title: "Tenant Improvements (TI)",
        },
        {
          id: "19",
          title: "Common area upgrades (cosmetic)",
        },
      ],
    },
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const selectCharge = (data) => {
    setSelectedCharges((prev) => [...prev, data.title]);
    setAdditionalList({
      ...additionalChargesList,
      title: data.title,
    });
    setSelectOpt(data.title);
    toggleMenu();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [additionalChargesList, setAdditionalList] = useState({
    title: "",
    description: "",
    amount: "",
  });

  const RentRuctureList = () => {
    const data = formData.additionalCharges;
    const baseRent = formData.unitInfo?.rent || 0;
    const rentType = formData.unitInfo?.rentType || "Monthly";

    return (
      <div className="w-full border-white !rounded-xl pb-2 mb-5">
        <table className="w-full border-2 rounded-md border-gray-100 shadow-sm">
          <thead className="">
            <tr className="!font-popinsRegular border-b border-black/20 text-darkColor/40 text-[13px]">
              <th className="py-2 pl-4 text-left w-[27%]">Title</th>
              <th className="py-2 text-left w-[48%]">Description</th>
              <th className="py-2 pl-3 text-left w-[10%]">Amount</th>
              <th className="py-2 pr-3 text-right w-[15%]">Quick Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* Base Rent Row - Always shown and cannot be deleted */}
            <tr className="bg-themeColor/40 font-popinsMedium text-darkColor text-xs">
              <td className="pl-4 py-1">Base Rent</td>
              <td className="py-1 pr-3">
                <span className="line-clamp-1">
                  Unit rent ({rentType})
                </span>
              </td>
              <td className="py-1 pl-3">{`$ ${baseRent}`}</td>
              <td className="py-1">
                <div className="flex justify-end mr-8">
                  <div className="w-8 h-8"></div>
                </div>
              </td>
            </tr>
            {/* Additional Charges */}
            {data.map((row) => (
              <tr
                key={row.id}
                className="font-popinsMedium text-darkColor text-xs"
              >
                <td className="pl-4 py-1">{row?.title}</td>
                <td className="py-1 pr-3">
                  <span className="line-clamp-1">{row?.description}</span>
                </td>
                <td className="py-1 pl-3">{`$ ${row?.amount}`}</td>
                <td className="py-1">
                  <div className="flex justify-end mr-8">
                    <div className="bg-[#FF814E] cursor-pointer w-8 h-8 rounded-md flex items-center justify-center">
                      <Trash
                        onClick={() => {
                          onItemDeleteChanges(row);
                          setSelectedCharges((prev) =>
                            prev.filter((title) => title !== row.title)
                          );
                        }}
                        size={16}
                        color="#FFFF"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="w-[95%] mx-auto h-full">
      <div className="text-center h-[10%]">
        <ParagraphTag
          content="Rent Charges"
          classes="text-darkColor font-popinsSemiBold text-lg"
        />
        <ParagraphTag
          content="All the rent information is to be filled in this section."
          classes="text-darkColor/50 font-popinsMedium text-xs"
        />
      </div>
      <form className="overflow-y-scroll h-[80%] panelScroll px-1">
        <div className="text-center pt-2">
          <ParagraphTag
            content="Charge Late Fee?"
            classes="text-darkColor font-popinsSemiBold text-base"
          />
          <ParagraphTag
            content="Will you be charge late fee on this lease?"
            classes="text-darkColor/50 font-popinsMedium text-xs"
          />
        </div>

        <div className="flex w-[30%] mx-auto justify-between mt-4">
          <div
            key={"Yes"}
            className="w-[50%] cursor-pointer mx-1 flex flex-col items-center"
            onClick={(e) => {
              e.preventDefault();
              isChargeLate(true);
            }}
          >
            <IconCards
              mainClasses={`h-36 w-[130px] ${
                formData?.chargeLate ? "border-red-500 border-2" : ""
              }`}
              imgClasses="w-[40px]"
              path={"/assets/daashboard/create-propety/check.png"}
              title={"Yes"}
              titleClasses={"text-themeColor"}
            />
          </div>

          <div
            key={"No"}
            className="w-[50%] cursor-pointer mx-1 flex flex-col items-center"
            onClick={(e) => {
              e.preventDefault();
              isChargeLate(false);
            }}
          >
            <IconCards
              mainClasses={`h-36 w-[130px] ${
                !formData?.chargeLate ? "border-red-500 border-2" : ""
              }`}
              imgClasses="w-[40px]"
              path={"/assets/daashboard/create-propety/close.png"}
              title={"No"}
              titleClasses={"text-themeColor"}
            />
          </div>
          {/* {Funds?.map((item) => (
            <div
              key={item.title}
              className="w-[50%] cursor-pointer mx-1 flex flex-col items-center"
              onClick={() => {
                isChargeLate(item.title);
              }}
            >
              <IconCards
                mainClasses={`h-36 w-[130px] ${formData?.chargeLate ? "border-red-500 border-2" : ""
                  }`}
                imgClasses="w-[40px]"
                path={
                  formData?.chargeLate ? item.imagePathActiv : item.imagePath
                }
                title={item.title}
                titleClasses={
                  formData?.chargeLate ? "text-themeColor" : "text-darkColor"
                }
              />
            </div>
          ))} */}
        </div>
        {formData?.chargeLate && (
          <>
            <div className="flex justify-between pt-3 w-[65%] mx-auto">
              <div className="w-[49%]">
                <LabelTag
                  isStaric={false}
                  name="Percentage"
                  classes="!text-xs !font-popinsMedium"
                />
                <input
                  value={formData.latePercentage}
                  onChange={onLatePercentageChange}
                  type="number"
                  placeholder="e.g. 10%"
                  className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
                />
              </div>
              <div className="w-[49%]">
                <LabelTag
                  name="Number of Days"
                  isStaric={false}
                  className="text-darkColor text-left !text-xs !font-popinsMedium"
                  classes="!text-xs !font-popinsMedium"
                />
                <input
                  value={formData.graceDays}
                  onChange={onLateGraceDays}
                  type="number"
                  placeholder="e.g. 5"
                  className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
                />
              </div>
            </div>
            <div className="flex justify-between pt-3 w-[65%] mx-auto">
              <div className="w-[49%]">
                <LabelTag
                  isStaric={false}
                  name="Fixed Late Fee Amount ($)"
                  classes="!text-xs !font-popinsMedium"
                />
                <input
                  value={formData.lateFixedAmount}
                  onChange={onLateFixedAmountChange}
                  type="number"
                  placeholder="e.g. 500"
                  className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
                />
              </div>
              <div className="w-[49%]">
                <LabelTag
                  name="Interest Rate (%)"
                  isStaric={false}
                  className="text-darkColor text-left !text-xs !font-popinsMedium"
                  classes="!text-xs !font-popinsMedium"
                />
                <input
                  value={formData.lateInterestRate}
                  onChange={onLateInterestRateChange}
                  type="number"
                  placeholder="e.g. 5%"
                  className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
                />
              </div>
            </div>
          </>
        )}
        <div className="h-[1px] bg-darkColor/20 mt-7"></div>
        <div className="w-[85%] mx-auto flex justify-between mt-5">
          <div className="w-[5%] flex items-center pt-4">
            <ParagraphTag
              content=""
              classes={`text-themeColor font-popinsSemiBold pt-1 text-xs`}
            />
          </div>
          <div className="w-[28%]">
            <LabelTag
              isStaric={false}
              name="Charges"
              classes="!text-xs !font-popinsMedium"
            />
            {/* onClick={() => {
                        setSelectedStat(item);
                      }} */}
            <div className="w-full relative" ref={dropdownRef}>
              <div
                className="bg-bgColor cursor-pointer w-full mt-1 text-sm font-popinsRegular px-3 h-[39px] rounded-sm text-darkColor flex items-center"
                onClick={toggleMenu}
              >
                <p>{selectOpt}</p>
              </div>
              {isOpen && (
                <div className="bg-white shadow-xl py-3 flex flex-col border border-white/20 rounded-xl w-full right-0 bottom-[55px] absolute h-[230px] overflow-y-scroll form-scrollbar">
                  {chargeList.map((item, i) => (
                    <div key={i} className="mt-2">
                      <h4 className="px-4 pt-2 font-popinsSemiBold text-sm text-darkColor">
                        {item.heading}
                      </h4>
                      {item.list
                        .filter(
                          (opt) =>
                            !selectedCharges.includes(opt.title) &&
                            !formData?.additionalCharges?.some(
                              (charge) => charge.title === opt.title
                            )
                        )
                        .map((opt, j) => (
                          <p
                            key={j}
                            onClick={() => selectCharge(opt)}
                            className="text-darkColor font-popinsRegular cursor-pointer text-sm pt-4 pl-4 border-b-[1px] border-darkColor/20 pb-2 hover:bg-themeColor/10"
                          >
                            {opt.title}
                          </p>
                        ))}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* <input
              value={additionalChargesList.title}
              onChange={(e) => {
                setAdditionalList({
                  ...additionalChargesList,
                  title: e.target.value,
                });
              }}
              type="text"
              placeholder="Type here"
              className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
            /> */}
          </div>
          <div className="w-[28%]">
            <LabelTag
              isStaric={false}
              name="Description"
              classes="!text-xs !font-popinsMedium"
            />
            <input
              value={additionalChargesList.description}
              onChange={(e) => {
                setAdditionalList({
                  ...additionalChargesList,
                  description: e.target.value,
                });
              }}
              type="text"
              placeholder="Type here"
              className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
          <div className="w-[28%]">
            <LabelTag
              isStaric={false}
              name="Amount"
              classes="!text-xs !font-popinsMedium"
            />
            <input
              value={additionalChargesList.amount}
              onChange={(e) => {
                setAdditionalList({
                  ...additionalChargesList,
                  amount: e.target.value,
                });
              }}
              type="number"
              placeholder="Type here"
              className="w-full mt-1 text-sm bg-bgColor font-popinsRegular px-3 py-2 rounded-sm text-darkColor placeholder:text-zinc-700/50"
            />
          </div>
          {/* <div className="flex justify-end items-end pb-1 cursor-pointer w-[6%]">
            <div className="border-2 border-dangerColor w-7 h-7 rounded-md flex justify-center items-center">
              <Trash color="#E43B3B" size={16} />
            </div>
          </div> */}
        </div>
        <div className="flex w-full justify-between items-center py-5">
          <div className="w-[36%] h-[1px] bg-darkColor/20"></div>
          <div className="w-[25%]">
            <button
              onClick={(e) => {
                e.preventDefault();
                if (additionalChargesList.title === "") {
                  ShowError("Charges is required");
                } else if (additionalChargesList.amount === "") {
                  ShowError("Amount is required");
                } else {
                  onAdditionalCharges(additionalChargesList);
                  setAdditionalList({
                    ...additionalChargesList,
                    title: "",
                    description: "",
                    amount: "",
                  });
                  setSelectOpt("Select Charges");
                }
              }}
              className="flex justify-center items-center text-themeColor rounded-md border border-themeColor py-2 w-full text-xs font-popinsMedium"
            >
              <Plus size={15} color="#0381CA" />
              <span className="pl-2">Add New Charge</span>
            </button>
          </div>

          <div className="w-[36%] h-[1px] bg-darkColor/20"></div>
        </div>
        {formData?.unitInfo && <RentRuctureList />}
      </form>
      <div className="flex justify-center">
        <div className="w-[30%] flex gap-4">
          <ButtonTag
            onSubmit={() => {
              dispatch(LeaseAction.ChangePropertyCreateSteps(2));
            }}
            name="Back"
            classes="text-base text-center bg-gray-500 text-white"
          />
          <ButtonTag
            onSubmit={() => {
              if (
                formData.chargeLate &&
                (!formData.latePercentage ||
                  !formData.graceDays ||
                  formData.graceDays < 0 ||
                  !formData.lateFixedAmount ||
                  !formData.lateInterestRate)
              ) {
                ShowError("Please fill in all late fee fields before proceeding.");
                return;
              }
              dispatch(LeaseAction.ChangePropertyCreateSteps(4));
            }}
            name="Next"
            classes="text-base text-center bg-themeColor text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default RentCharges;
